import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { TimeEntryTypeKey } from '@/modules/timeentry/constants/TimeEntryTypeKey';

export class TimeEntryType extends Enum {
  key!: TimeEntryTypeKey;
  value!: string;
  color!: string;

  static ESTATE_WORK: TimeEntryType = {
    key: TimeEntryTypeKey.ESTATE_WORK,
    get value(): string {
      return Lang.t('Estate Work');
    },
    color: '#f0932b'
  };

  static CEI: TimeEntryType = {
    key: TimeEntryTypeKey.CEI,
    get value(): string {
      return Lang.t('CE Investment');
    },
    color: '#516AF2'
  };

  static PTO: TimeEntryType = {
    key: TimeEntryTypeKey.PTO,
    get value(): string {
      return Lang.t('timetracking.time-off');
    },
    color: '#e056fd'
  };

  static NON_WORK_RELATED: TimeEntryType = {
    key: TimeEntryTypeKey.NON_WORK_RELATED,
    get value(): string {
      return Lang.t('timetracking.social-events');
    },
    color: '#6ab04c'
  };

  static isEstateWork(key: string): boolean {
    return key === TimeEntryType.ESTATE_WORK.key;
  }
}
